export const NotificationsTypeKeys = {
    add_contact: 'add_contact',
    user_message: 'user_message',
    event_broadcast: 'event_broadcast',
    missed_call: 'missed_call',
}
